module.exports = __webpack_public_path__ + "img/oneswap_icon.4a15e214.png";